import kebabCase from 'lodash/kebabCase';

export const testProps = (id: string) => {
  return {
    'data-testid': id,
  };
};

export const sluggify = (id = '') => kebabCase(id.substring(0, 30));
